// Orders
import { OrderBrandForm } from "./forms/cdp/orders/OrderBrandForm";
import { OrderCityForm } from "./forms/cdp/orders/OrderCityForm";
import { OrderClimaticFeatureForm } from "./forms/cdp/orders/OrderClimaticFeatureForm";
import { OrderCountryForm } from "./forms/cdp/orders/OrderCountryForm";
import { OrderDateAndHourForm } from "./forms/cdp/orders/OrderDateAndHourForm";
import { OrderDayForm } from "./forms/cdp/orders/OrderDayForm";
import { OrderDayWeekForm } from "./forms/cdp/orders/OrderDayWeekForm";
import { OrderDeliveryFeeForm } from "./forms/cdp/orders/OrderDeliveryFeeForm";
import { OrderMoistureForm } from "./forms/cdp/orders/OrderMoistureForm";
import { OrderMonthForm } from "./forms/cdp/orders/OrderMonthForm";
import { OrderNeighborhoodForm } from "./forms/cdp/orders/OrderNeighborhoodForm";
import { OrderOriginSaleForm } from "./forms/cdp/orders/OrderOriginSaleForm";
import { OrderSourceDataForm } from "./forms/cdp/orders/OrderSourceDataForm";
import { OrderStateForm } from "./forms/cdp/orders/OrderStateForm";
import { OrderTemperatureForm } from "./forms/cdp/orders/OrderTemperatureForm";
import { OrderThermalSensationForm } from "./forms/cdp/orders/OrderThermalSensationForm";
import { OrderUnitForm } from "./forms/cdp/orders/OrderUnitForm";
import { OrderValueForm } from "./forms/cdp/orders/OrderValueForm";
import { OrderWeekForm } from "./forms/cdp/orders/OrderWeekForm";
import { OrderYearForm } from "./forms/cdp/orders/OrderYearForm";
// Customers
import { CustomerAverageTicketForm } from "./forms/cdp/customers/CustomerAverageTicketForm";
import { CustomerBirthdayForm } from "./forms/cdp/customers/CustomerBirthdayForm";
import { CustomerDateAndHourForm } from "./forms/cdp/customers/CustomerDateAndHourForm";
import { CustomerDayRegistrationForm } from "./forms/cdp/customers/CustomerDayRegistrationForm";
import { CustomerDayWeekRegistrationForm } from "./forms/cdp/customers/CustomerDayWeekRegistrationForm";
import { CustomerDaysWithoutConversionForm } from "./forms/cdp/customers/CustomerDaysWithoutConversionForm";
import { CustomerDocForm } from "./forms/cdp/customers/CustomerDocForm";
import { CustomerEmailForm } from "./forms/cdp/customers/CustomerEmailForm";
import { CustomerFrequencyOrdersForm } from "./forms/cdp/customers/CustomerFrequencyOrdersForm";
import { CustomerGenderForm } from "./forms/cdp/customers/CustomerGenderForm";
import { CustomerHourRegistrationForm } from "./forms/cdp/customers/CustomerHourRegistrationForm";
import { CustomerLastAttForm } from "./forms/cdp/customers/CustomerLastAttForm";
import { CustomerLastOrderForm } from "./forms/cdp/customers/CustomerLastOrderForm";
import { CustomerMarketingForm } from "./forms/cdp/customers/CustomerMarketingForm";
import { CustomerMonthRegistrationForm } from "./forms/cdp/customers/CustomerMonthRegistrationForm";
import { CustomerNameForm } from "./forms/cdp/customers/CustomerNameForm";
import { CustomerPhoneForm } from "./forms/cdp/customers/CustomerPhoneForm";
import { CustomerQuantityOrdersForm } from "./forms/cdp/customers/CustomerQuantityOrdersForm";
import { CustomerRFVForm } from "./forms/cdp/customers/CustomerRFVForm";
import { CustomerTotalSpendForm } from "./forms/cdp/customers/CustomerTotalSpendForm";
import { CustomerWeekRegistrationForm } from "./forms/cdp/customers/CustomerWeekRegistrationForm";
import { CustomerYearRegistrationForm } from "./forms/cdp/customers/CustomerYearRegistrationForm";
// Coupons
import { CouponCodeForm } from "./forms/cdp/coupons/CouponCodeForm";
import { CouponDayAndHourForm } from "./forms/cdp/coupons/CouponDayAndHourForm";
import { CouponDayForm } from "./forms/cdp/coupons/CouponDayForm";
import { CouponDayWeekForm } from "./forms/cdp/coupons/CouponDayWeekForm";
import { CouponDaysExpForm } from "./forms/cdp/coupons/CouponDaysExpForm";
import { CouponDiscountForm } from "./forms/cdp/coupons/CouponDiscountForm";
import { CouponExpDateForm } from "./forms/cdp/coupons/CouponExpDateForm";
import { CouponExpDateReminderForm } from "./forms/cdp/coupons/CouponExpDateReminderForm";
import { CouponHourForm } from "./forms/cdp/coupons/CouponHourForm";
import { CouponMinOrderForm } from "./forms/cdp/coupons/CouponMinOrderForm";
import { CouponMonthForm } from "./forms/cdp/coupons/CouponMonthForm";
import { CouponTypeForm } from "./forms/cdp/coupons/CouponTypeForm";
import { CouponWeekForm } from "./forms/cdp/coupons/CouponWeekForm";
import { CouponYearForm } from "./forms/cdp/coupons/CouponYearForm";
// Products
import { ProductCategoryForm } from "./forms/cdp/products/ProductCategoryForm";
import { ProductDayAndHourForm } from "./forms/cdp/products/ProductDayAndHourForm";
import { ProductDayForm } from "./forms/cdp/products/ProductDayForm";
import { ProductDayWeekForm } from "./forms/cdp/products/ProductDayWeekForm";
import { ProductHourForm } from "./forms/cdp/products/ProductHourForm";
import { ProductMonthForm } from "./forms/cdp/products/ProductMonthForm";
import { ProductNameForm } from "./forms/cdp/products/ProductNameForm";
import { ProductQuantityForm } from "./forms/cdp/products/ProductQuantityForm";
import { ProductSKUForm } from "./forms/cdp/products/ProductSKUForm";
import { ProductSizeForm } from "./forms/cdp/products/ProductSizeForm";
import { ProductValueForm } from "./forms/cdp/products/ProductValueForm";
import { ProductWeekForm } from "./forms/cdp/products/ProductWeekForm";
import { ProductYearForm } from "./forms/cdp/products/ProductYearForm";
import { ProfileClimateForm } from "./forms/cdp/profiles/ProfileClimateForm";
import { ProfileMomentDayForm } from "./forms/cdp/profiles/ProfileMomentDayForm";
import { ProfileMomentWeekForm } from "./forms/cdp/profiles/ProfileMomentWeekForm";
import { ProfileRFVForm } from "./forms/cdp/profiles/ProfileRFVForm";
import { ProfileSeasonForm } from "./forms/cdp/profiles/ProfileSeasonForm";
import { ProfileTemperatureForm } from "./forms/cdp/profiles/ProfileTemperatureForm";
import { CustomerAgeForm } from "./forms/cdp/customers/CustomerAgeForm";

export const NodeForms = {
  // Orders
  "o.created_at": OrderDateAndHourForm,
  "o.order_total": OrderValueForm,
  "o.delivery_total": OrderDeliveryFeeForm,
  "o.brand_id": OrderBrandForm,
  "o.unit_id": OrderUnitForm,
  "o.source_id": OrderSourceDataForm,
  "o.order_origin": OrderOriginSaleForm,
  "o.delivery_city": OrderCityForm,
  "o.delivery_state": OrderStateForm,
  "o.delivery_country": OrderCountryForm,
  "o.delivery_region": OrderNeighborhoodForm,
  "w.temperature": OrderTemperatureForm,
  "w.feelslike": OrderThermalSensationForm,
  "w.humidity": OrderMoistureForm,
  "w.condition": OrderClimaticFeatureForm,
  "o.year": OrderYearForm,
  "o.day": OrderDayForm,
  "o.week": OrderWeekForm,
  "o.week_day": OrderDayWeekForm,
  "o.month": OrderMonthForm,

  // Customers
  "c.age": CustomerAgeForm,
  "c.created_at": CustomerDateAndHourForm,
  "c.name": CustomerNameForm,
  "c.email": CustomerEmailForm,
  "c.phone": CustomerPhoneForm,
  "c.doc": CustomerDocForm,
  "c.birthdate": CustomerBirthdayForm,
  CustomerGender: CustomerGenderForm,
  "c.updated_at": CustomerLastAttForm,
  "c.sum_order": CustomerTotalSpendForm,
  "c.quantity": CustomerQuantityOrdersForm,
  "c.rfv_profile": CustomerRFVForm,
  "c.average_order": CustomerAverageTicketForm,
  "c.order_frequency": CustomerFrequencyOrdersForm,
  "c.last_conversion": CustomerLastOrderForm,
  "c.consent": CustomerMarketingForm,
  "c.created_at_hour": CustomerHourRegistrationForm,
  "c.created_at_day": CustomerDayRegistrationForm,
  "c.created_at_week": CustomerWeekRegistrationForm,
  "c.created_at_weekday": CustomerDayWeekRegistrationForm,
  "c.created_at_year": CustomerYearRegistrationForm,
  "c.created_at_month": CustomerMonthRegistrationForm,
  "c.days_without_conversion": CustomerDaysWithoutConversionForm,

  // Coupons
  "cc.used_at": CouponDayAndHourForm,
  "cc.code": CouponCodeForm,
  "cc.type": CouponTypeForm,
  "cc.value": CouponDiscountForm,
  "cc.min_order": CouponMinOrderForm,
  "cc.expires_at_days_diff": CouponDaysExpForm,
  "cc.expires_at": CouponExpDateForm,
  "cc.remind_gain_date": CouponExpDateReminderForm,
  "cc.used_at_hour": CouponHourForm,
  "cc.used_at_day": CouponDayForm,
  "cc.used_at_week": CouponWeekForm,
  "cc.used_at_weekday": CouponDayWeekForm,
  "cc.used_at_month": CouponMonthForm,
  "cc.used_at_year": CouponYearForm,

  // Products
  "p.created_at": ProductDayAndHourForm,
  "p.sku": ProductSKUForm,
  "p.name": ProductNameForm,
  "p.quantity": ProductQuantityForm,
  "p.created_at_hour": ProductHourForm,
  "p.total": ProductValueForm,
  "p.size_name": ProductSizeForm,
  "p.category_name": ProductCategoryForm,
  "p.created_at_year": ProductYearForm,
  "p.created_at_month": ProductMonthForm,
  "p.created_at_day": ProductDayForm,
  "p.created_at_week": ProductWeekForm,
  "p.created_at_weekday": ProductDayWeekForm,

  "pp.rfv": ProfileRFVForm,
  "pp.climate": ProfileClimateForm,
  "pp.moment_week": ProfileMomentWeekForm,
  "pp.moment_day": ProfileMomentDayForm,
  "pp.season": ProfileSeasonForm,
  "pp.temperature": ProfileTemperatureForm,
};
